import AttachmentWellHost from 'owa-calendar-meeting-forms-common-store/lib/store/schema/AttachmentWellHost';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { action } from 'satcheljs/lib/legacy';
import {
    lazyGetAttachmentWellInitialValue,
    lazyInitializeAttachments,
    lazyReinitializeAttachments,
} from 'owa-attachment-well-data';
import { isConnectedAccount } from 'owa-accounts-store';
import AttachmentMenuAction from 'owa-attachment-full-data/lib/schema/AttachmentMenuAction';

let currentComposeId = 1;

/**
 * Initialize the attachment well viewstate in the store.viewState.
 * @param calendarEvent CalendarEvent object which has the attachments
 * @param reInitialize the boolean which represents if we have to reinitialize the attachment well
 * @param state the InitAttachmentWellState which contains the state of the store which contains AttachmentWellViewState
 */
export default action('initAttachmentWell')(async function initAttachmentWell(
    calendarEvent: CalendarEvent,
    reInitialize: boolean,
    attachmentWellHost: AttachmentWellHost,
    isReadOnly: boolean = true
) {
    if (!calendarEvent) {
        return;
    }
    let getAttachmentWellInitialValue = await lazyGetAttachmentWellInitialValue.import();

    // Initialize attachmentWell in the store
    attachmentWellHost.attachmentWell = getAttachmentWellInitialValue(
        isReadOnly,
        false /* isInitialized */,
        currentComposeId.toString() // not in a compose session but an Id is needed for link plugin
    );

    currentComposeId++;
    const mailboxInfo = calendarEvent.ParentFolderId.mailboxInfo;
    const isAConnectedAccount = isConnectedAccount(mailboxInfo.userIdentity);

    // Those menu actions are temporary unsupported for connected account
    const unsupportedMenuActions: AttachmentMenuAction[] = isAConnectedAccount
        ? [
              AttachmentMenuAction.ConvertClassicToCloudy,
              AttachmentMenuAction.SaveToCloud,
              AttachmentMenuAction.MoveAttachmentToInline,
              AttachmentMenuAction.Preview,
          ]
        : [];

    if (reInitialize) {
        await lazyReinitializeAttachments.importAndExecute(
            calendarEvent.Attachments,
            mailboxInfo,
            attachmentWellHost.attachmentWell,
            true /* forceUpdateAttachmentsInStore */,
            unsupportedMenuActions
        );
    } else {
        await lazyInitializeAttachments.importAndExecute(
            calendarEvent.Attachments,
            mailboxInfo,
            attachmentWellHost.attachmentWell,
            true /* forceUpdateAttachmentsInStore */,
            false /* isInitializationForCompose */,
            unsupportedMenuActions
        );
    }
});
